// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

// Shared "restore in progress" (maintenance) flag.
//
// During a restore the backup sidecar DROPs+recreates the databases and restarts
// the backend + app services — so for ~1–2 minutes the backend is intentionally
// down and every background poll returns 502. nginx, the frontend, and the sidecar
// stay up, so the sidecar's /api/backup/progress endpoint is the source of truth.
//
// Background pollers check isMaintenance() and skip their fetch while a restore is
// running, instead of flooding the console with 502s. The poller that drives this
// flag lives in utils/axiosConfig.js.
let _active = false;
const _listeners = new Set();

export const isMaintenance = () => _active;

export const setMaintenance = (value) => {
  const next = !!value;
  if (next === _active) return;
  _active = next;
  _listeners.forEach((cb) => {
    try {
      cb(_active);
    } catch (_) {
      /* ignore listener errors */
    }
  });
};

// Subscribe to changes; returns an unsubscribe fn. cb receives the new boolean.
export const subscribeMaintenance = (cb) => {
  _listeners.add(cb);
  return () => _listeners.delete(cb);
};
